export const MSG_TYPES = {
  text: 'text',
  message: 'message',
  session: 'session',
  file: 'file',
  attachment: 'attachment',
  pxbill: 'pxbill',
  /**
   * type in order message
   */
  msg: 'msg',
  paymentdetails: 'paymentdetails',
  ordersummary: 'ordersummary',
  orderstatus: 'orderstatus',

  /**
   * used by px portal only, for custom components
   */
  multipleAttachments: 'multipleAttachments',

  labtest: 'labtest',
  prescription: 'prescription',
  educ: 'educ',
}

export const MIME_TYPES = {
  pdf: 'application/pdf',
  video: 'video/mp4',
  text: 'text/plain',
  png: 'image/png',
  jpg: 'image/jpg',
  jpeg: 'image/jpeg',
}

//the file types the chat can render back, used as the attachment input filter
export const ATTACHMENT_ACCEPT = Object.values(MIME_TYPES).join(',');

//the date property from each message type for sorting
export const DATE_PROP_MSG_TYPE = {
  [MSG_TYPES.text]: 'date',
  [MSG_TYPES.msg]: 'date',
  [MSG_TYPES.multipleAttachments]: 'date',
  [MSG_TYPES.message]: 'date',
  [MSG_TYPES.session]: 'start_date',
  [MSG_TYPES.file]: 'received',
  [MSG_TYPES.pxbill]: 'date',
  [MSG_TYPES.attachment]: 'datecreated',
  [MSG_TYPES.educ]: 'received',
}

//the 'msg' property as preview for the message on the list of messages
export const MESSAGE_PROP_MSG_TYPE = {
  [MSG_TYPES.text]: 'msg',
  [MSG_TYPES.message]: 'msg',
  [MSG_TYPES.session]: 'channelname',
  [MSG_TYPES.file]: 'msg',
  [MSG_TYPES.pxbill]: 'date', //not sure with this
  [MSG_TYPES.attachment]: 'msg',
  [MSG_TYPES.labtest]: 'msg',
}
